import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'v1/invoices';

class invoiceService {
  async generateInvoice(companyId, month, year, extended) {
    return axios.post(`${API_URL}/${companyId}`, { month, year, extended }, {
      responseType: 'blob'
    });
  }

  async generateSpec(companyId, month, year) {
    return axios.post(`${API_URL}/specialization/${companyId}`, { month, year }, {
      responseType: 'blob'
    });
  }

  async getAllByCompanyId(companyId) {
    return axios.get(`${API_URL}/company/${companyId}`);
  }
  
  async downloadInvoice(invoiceId) {
    return axios.get(`${API_URL}/download/${invoiceId}`, {
      responseType: 'blob'
    });
  }

  async regenerateInvoice(invoiceNumber) {
    return axios.get(`${API_URL}/regenerate/${invoiceNumber}`, {}, {
      responseType: 'blob'
    });
  }
}

export default new invoiceService();